import axios from 'axios'
import moment from 'moment'

import config from '../../config'
import store from '../../store'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import {ELASTIC_TOKEN} from '../../config'

async function elaticsearchQuery(querys) {
  if(!store.state.config) return // store還沒load到config的情況避免npe
  const result = await axios.post(
    encodeURI(`${config.dynamicElaticSearchApi()}<people-*>/_search`),
    querys,
    {
      crossdomain: true,
      headers: {
        authorization: `Basic ${store.state.config.elasticAuthToken}`,
        'content-type': 'application/json'
      }
    }
  )
  return result
}

async function elaticsearchMutiQuery(querys) {
  if(!store.state.config) return // store還沒load到config的情況避免npe
  const result = await axios.post(
    encodeURI(`${config.dynamicElaticSearchApi()}<people-*>/_msearch`),
    querys,
    {
      crossdomain: true,
      headers: {
        authorization: `Basic ${store.state.config.elasticAuthToken}`,
        'content-type': 'application/x-ndjson'
      }
    }
  )
  return result
}

export async function getMutiStreetObjectDetection(condition = {}) {
  // const queryTimeUnit = Utils.isEmptyString(condition.unit) ? 'h' : condition.unit
  // const queryTime = Utils.isEmptyObject(condition.value) ? 1 : condition.value
  const queryTimeUnit = 'h'
  const queryTime = 1

  const now = moment()
  const result = await elaticsearchQuery({
    query: {
      range: {
        '@timestamp': {
          gte: moment().subtract(queryTime, queryTimeUnit).valueOf(),
          lte: now.valueOf(),
          format: 'epoch_millis'
        }
      }
    },
    sort: {
      '@timestamp': {
        order: 'desc'
      }
    },
    size: 1,
    aggs: {
      data: {
        terms: {
          field: 'ObjectType.keyword',
          size: CONST.ELK_SEARCH_MAX_SIZE,
          min_doc_count: 0
        },
        aggs: {
          data: {
            terms: {
              field: 'StreamID.keyword',
              size: CONST.ELK_SEARCH_MAX_SIZE,
              min_doc_count: 0
            }
          }
        }
      }
    }
  })

  return handleAggsData(result)
}

export async function getPeople(condition = {}) {
  if (Utils.isEmptyObject(condition)) {
    return []
  }

  const streamIds = Utils.isEmptyObject(condition.streamIds) ? [] : condition.streamIds
  // const streamIds = ['6aa31802-8081-4d19-8f03-240b67e984f8']
  const queryTimeUnit = Utils.isEmptyString(condition.unit) ? 'd' : condition.unit
  const queryTime = Utils.isEmptyObject(condition.value) ? -1 : condition.value
  const startTime = Utils.isEmptyObject(condition.startTime) ? undefined : condition.startTime
  const endTime = Utils.isEmptyObject(condition.endTime) ? undefined : condition.endTime
  const objectTypes = Utils.isEmptyObject(condition.objectTypes) ? [] : condition.objectTypes
  const objectColors = Utils.isEmptyObject(condition.objectColors) ? [] : condition.objectColors
  const isFilterSize = Utils.isEmptyObject(condition.isFilterSize) ? false : condition.isFilterSize
  const minXInput = condition.minXInput
  const maxXInput = condition.maxXInput
  const minYInput = condition.minYInput
  const maxYInput = condition.maxYInput

  const lte = endTime ? moment(endTime) : moment()
  const gte = startTime ? moment(startTime) : moment().subtract(queryTime, queryTimeUnit) // 萬一沒有起訖時間則搜尋一天前

  const query = {
    query: {
      bool: {
        filter: [
          {
            range: { // https://discuss.elastic.co/t/multiple-range-filters-for-same-field/73898/2
              '@timestamp': {
                gte: gte.valueOf(),
                lte: lte.valueOf(),
                format: 'epoch_millis'
              }
            }
          },
        ]
      }
    },
    sort: {
      '@timestamp': {
        order: 'desc'
      }
    },
    size: CONST.ELK_SEARCH_MAX_SIZE
  }

  // ------filter stream id
  if (!Utils.isEmptyObject(streamIds)) {
    const streamIdString = Utils.getESQueryStreamingId(streamIds)
    const queryStreamingIds = {
      query_string: {
        analyze_wildcard: true,
        query: streamIdString
      }
    }
    query.query.bool.filter.push(queryStreamingIds)
  }

  // ------filter object Width
  if (isFilterSize && !Utils.isEmptyObject(minXInput) && !Utils.isEmptyObject(maxXInput)) {
    const queryWidth = {
      range: {
        Width: {
          gte: minXInput,
          lte: maxXInput
        }
      }
    }

    query.query.bool.filter.push(queryWidth)
  }

  // ------filter object Height
  if (isFilterSize && !Utils.isEmptyObject(minYInput) && !Utils.isEmptyObject(maxYInput)) {
    const queryHeight = {
      range: {
        Height: {
          gte: minYInput,
          lte: maxYInput
        }
      }
    }

    query.query.bool.filter.push(queryHeight)
  }

  // ------filter object Type
  const typeString = Utils.getESQueryByObjectType(objectTypes)
  if (!Utils.isEmptyString(typeString)) {
    const queryType = {
      query_string: {
        query: typeString,
        fields: ['ObjectType']
      }
    }
    query.query.bool.filter.push(queryType)
  }

  // ------filter object Color
  if (!Utils.isEmptyObject(objectColors)) {
    let colorString = '' // query: `( ${color1} ) OR ( ${color2} )`

    for (let i = 0; i < objectColors.length; i++) {
      colorString = colorString + '(' + objectColors[i] + ')'
      if (i < objectColors.length - 1) { colorString = colorString + ' OR ' }
    }

    const queryColor = {
      query_string: {
        query: colorString,
        fields: ['Color']
      }
    }
    query.query.bool.filter.push(queryColor)
  }

  const result = await elaticsearchQuery(query)
  return Utils.isEmptyObject(result)? [] : result.data.hits.hits
}

function handleAggsData(ESResult) {
  const buckets = ESResult.data.aggregations.data.buckets
  const objectType = []
  const streamingIdSortData = []

  for (let i = 0; i < buckets.length; i++) {
    objectType.push(buckets[i].key)
    for (let j = 0; j < buckets[i].data.buckets.length; j++) {
      if (Utils.isEmptyObject(buckets[i].data.buckets[j])) continue

      const existData = streamingIdSortData.find(element => element.id === buckets[i].data.buckets[j].key)
      if (Utils.isEmptyObject(existData)) {
        // 建立新的steamId資料
        const data = { id: buckets[i].data.buckets[j].key }

        data[buckets[i].key] = buckets[i].data.buckets[j].doc_count
        data.all = buckets[i].data.buckets[j].doc_count
        streamingIdSortData.push(data)
      } else {
        // 在原有steamId資料加入
        existData[buckets[i].key] = buckets[i].data.buckets[j].doc_count
        existData.all = existData.all + buckets[i].data.buckets[j].doc_count
      }
    }
  }

  const result = {
    objectType: objectType.sort(),
    streamingSort: streamingIdSortData
  }
  return result
}

export async function getCountPerDay(condition = {}) {
  const streamingIds = Utils.isEmptyObject(condition.streamingIds) ? [] : condition.streamingIds
  const interval = Utils.isEmptyObject(condition.interval) ? '1d' : condition.interval
  // const dataType = Utils.isEmptyObject(condition.dataType) ? CONST.TYPE_OBJECT_DETECTION : condition.dataType
  const startTime = Utils.isEmptyObject(condition.startTime) ? undefined : condition.startTime
  const endTime = Utils.isEmptyObject(condition.endTime) ? undefined : condition.endTime
  const objectTypes = Utils.isEmptyObject(condition.objectTypes) ? [] : condition.objectTypes
  const messageDirection = Utils.isEmptyObject(condition.message) ? '(in)' : condition.message

  const queryStreamId = Utils.getESQueryStreamingId(streamingIds)
  const intervalUnit = interval.split('')[interval.length - 1]
  const intervalValue = Number(interval.replace(intervalUnit, ''))

  let offset = '+0m'
  // if ((intervalValue > 1 && intervalUnit === 'm') || intervalUnit === 'h') {
  //   const st = moment(startTime).startOf('h')
  //   const diffTime = moment.duration(moment(startTime).diff(st)).as('m')
  //   const modNum = diffTime % intervalValue
  //   offset = `+${modNum}m`
  //   if (intervalUnit === 'h' || intervalValue > 30) {
  //     offset = `+${st.hours() * 60 + modNum}m`
  //   }
  // }
  // if (intervalUnit === 'd') {
  //   offset = '+0h'
  // }

  const query = {
    query: {
      bool: {
        filter: [
          {
            range: {
              '@timestamp': {
                gte: startTime.valueOf(),
                lte: endTime.valueOf(),
                format: 'epoch_millis'
              }
            }
          },
          {
            query_string: {
              analyze_wildcard: true,
              query: queryStreamId
            }
          },
          {
            query_string: {
              query: messageDirection,
              fields: ['Message']
            }
          }
        ]
      }
    },
    size: 1,
    aggs: {
      data: {
        date_histogram: {
          field: '@timestamp',
          interval: interval,
          min_doc_count: 0,
          offset: offset,
          time_zone: '+08:00',
          format: 'epoch_millis'
        }
      }
    }
  }

  // ------filter object Type
  const typeString = Utils.getESQueryByObjectType(objectTypes)
  if (!Utils.isEmptyString(typeString)) {
    const queryType = {
      query_string: {
        query: typeString,
        fields: ['ObjectType']
      }
    }
    query.query.bool.filter.push(queryType)
  }

  const queryResult = await elaticsearchQuery(query)
  return handleCountPerDayData(queryResult)
}

function handleCountPerDayData(ESResult) {
  if (Utils.isEmptyObject(ESResult) ||(ESResult.status < 200 && ESResult.status >= 300) ) {
    return {}
  }

  const buckets = ESResult.data.aggregations.data.buckets // [{key_as_string: '1632412800000', key: 1632412800000, doc_count: 34642}, {key_as_string: '1632499200000', key: 1632499200000, doc_count: 32198}]

  const result = buckets.reduce((obj, element) => {
    obj[element.key_as_string] = element.doc_count
    return obj
  }, {})
  return result
}

// function generateWeeklyQuery(streamingIds,
//   startTime,
//   endTime,
//   interval = '1h',
//   dataType = CONST.TYPE_OBJECT_DETECTION,
//   objectTypes) {
//   const queryStreamId = Utils.getStreamingId(streamingIds)
//   const intervalUnit = interval.split('')[interval.length - 1]
//   const intervalValue = Number(interval.replace(intervalUnit, ''))
//   let offset = '+0m'
//   if ((intervalValue > 1 && intervalUnit === 'm') || intervalUnit === 'h') {
//     const st = moment(startTime).startOf('h')
//     const diffTime = moment.duration(moment(startTime).diff(st)).as('m')
//     const modNum = diffTime % intervalValue
//     offset = `+${modNum}m`
//     if (intervalUnit === 'h' || intervalValue > 30) {
//       offset = `+${st.hours() * 60 + modNum}m`
//     }
//   }
//   if (intervalUnit === 'd') {
//     offset = '+0h'
//   }

//   const query = {
//     query: {
//       bool: {
//         filter: [
//           {
//             range: {
//               '@timestamp': {
//                 gte: startTime.valueOf(),
//                 lte: endTime.valueOf(),
//                 format: 'epoch_millis'
//               }
//             }
//           },
//           {
//             query_string: {
//               analyze_wildcard: true,
//               query: queryStreamId
//             }
//           }
//         ]
//       }
//     },
//     size: 1,
//     aggs: {
//       data: {
//         date_histogram: {
//           field: '@timestamp',
//           interval: interval,
//           min_doc_count: 0,
//           offset: offset,
//           time_zone: '+08:00',
//           format: 'epoch_millis'
//         }
//       }
//     }
//   }

//   // ------filter object Type
//   const typeString = Utils.getESQueryByObjectType(objectTypes)
//   if (!Utils.isEmptyString(typeString)) {
//     const queryType = {
//       query_string: {
//         query: typeString,
//         fields: ['ObjectType']
//       }
//     }
//     query.query.bool.filter.push(queryType)
//   }

//   return query
// }

// export async function getMutiWeeklyData(condition) {
//   const queryTimeObjs = Utils.isEmptyObject(condition.queryTimeObjs) ? [] : condition.queryTimeObjs
//   const streamingIds = Utils.isEmptyObject(condition.streamingIds) ? [] : condition.streamingIds
//   const interval = Utils.isEmptyObject(condition.interval) ? '1h' : condition.interval
//   const dataType = Utils.isEmptyObject(condition.dataType) ? CONST.TYPE_OBJECT_DETECTION : condition.dataType
//   const objectTypes = Utils.isEmptyObject(condition.objectTypes) ? [] : condition.objectTypes

//   const querys = queryTimeObjs.map(qto => {
//     return `{}\n${JSON.stringify(
//       generateWeeklyQuery(streamingIds, qto.startTime, qto.endTime, interval, dataType, objectTypes)
//     )}\n`
//   }).join('')
//   const result = await elaticsearchMutiQuery(querys)
//   return handleWeeklyData(result)
// }

// function handleWeeklyData(ESResult) {
//   if (ESResult.status < 200 && ESResult.status >= 300) {
//     return []
//   }

//   const result = []
//   // const buckets = ESResult.data.aggregations.data.buckets
//   ESResult.data.responses.forEach(element => {
//     const buckets = element.aggregations.data.buckets
//     const data = buckets.reduce((obj, element) => {
//       obj[element.key_as_string] = element.doc_count
//       return obj
//     }, {})

//     result.push(data)
//   })
//   return result
// }
